import { render, staticRenderFns } from "./ModView.vue?vue&type=template&id=4d40098a&"
import script from "./ModView.vue?vue&type=script&lang=js&"
export * from "./ModView.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports